import { useEffect, useState, useRef } from "react"

const useAfterInitialEffect = (callback, deps) => {
    const isInitialMount = useRef(true);
    const [hasRun, setHasRun] = useState(false);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            callback();
            setHasRun(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return hasRun;
}

export default useAfterInitialEffect